import { Component, OnInit, OnDestroy, Input, inject, TemplateRef } from '@angular/core';
import { select } from '@ngrx/store';
import { getLinescoreEntity, getLinescoreLoaded, getEnabled, getStagedItems } from '../store';
import { filter, switchMap, take } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { LinescoreTabData } from '../models';
import { ReportTab } from '../report-tab.class';
import { ModTable } from 'core-lib';
import pptxgen from 'pptxgenjs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDividerModule } from '@angular/material/divider';
import { ChartPickerComponent } from '../chart-picker/chart-picker.component';
import { LsTableComponent } from '../ls-table/ls-table.component';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { RevLinescaleComponent } from 'runtime/components/rev-linescale/rev-linescale.component';
import { LinescaleComponent } from 'linescale/linescale.component';
// import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LinescaleWrapperComponent } from "../linescale-wrapper/linescale-wrapper.component";

@Component({
  selector: 'ls-linescore-tab',
  // changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './linescore-tab.component.html',
  styleUrls: ['./linescore-tab.component.scss'],
  standalone: true,
  imports: [MatIconModule, LsTableComponent, ChartPickerComponent, LinescaleComponent, MatDividerModule, MatProgressSpinnerModule, RevLinescaleComponent, CommonModule, MatButtonModule, MatTooltipModule, LinescaleWrapperComponent]
})
export class LinescoreTabComponent extends ReportTab implements OnInit, OnDestroy {

  tabDataSub: Subscription;
  editingSub: Subscription;
  exporting: boolean;
  tabData: LinescoreTabData;
  tables: ModTable[];
  table1: any;
  // exportItems = new Map<string, boolean>();
  selectedSub: Subscription;
  preSelected = {};
  readonly pptx = new pptxgen();

  helper = this.showHelp('linescore_tab');

  testMe(tableId: string) {
    // const slide = this.pptx.addSlide();
    // slide.addText('Hello World from PptxGenJS...', {
    //     x: 1.5, y: 1.5, w: '50%', color: '6002EE', fill: { color: '90ee02' },
    //     align: 'center', fontSize: 24, h: '2'
    // });
    // this.pptx.writeFile({ fileName: 'test_pres263.pptx' });
    this.pptx.tableToSlides(tableId, { x: 1, y: 1, w: 10 });
    this.pptx.writeFile({ fileName: 'table2slides_demo.pptx' });
  }

  ngOnInit() {
    super.ngOnInit();
    this.tabDataSub = this.store.pipe(
      select(getLinescoreLoaded),
      filter(loaded => loaded),
      // take(1),
      switchMap(() => this.store.pipe(select(getLinescoreEntity), take(1)))
    ).subscribe(data => {
      this.tabData = data;
      // console.log(data);

      const myTable = data.diagnostics[0].table;
      const myTableArr = [];
      myTableArr[0] = myTable.header_row.map(col => col.value);
      myTable.body.forEach(row => {
        myTableArr.push(myTable.displayedCols.map(col => row[col]))
      });
      this.table1 = (data.tables as Array<any>).find(table => table.id === 'linescore_1').body[0];
      this.tables = data.tables;
    });
    this.editingSub = this.store.pipe(
      select(getEnabled)
    ).subscribe(enabled => {
      this.exporting = enabled;
    });
    this.selectedSub = this.store.pipe(
      select(getStagedItems),
      // take(1)
    ).subscribe(entities => {
      this.preSelected = entities;
    });

  }

  ngOnDestroy() {
    this.tabDataSub.unsubscribe();
    this.editingSub.unsubscribe();
    this.selectedSub.unsubscribe();
  }

}
